import { render, staticRenderFns } from "./PuzzleSolutionGrid.vue?vue&type=template&id=22303b9a"
import script from "./PuzzleSolutionGrid.vue?vue&type=script&lang=js"
export * from "./PuzzleSolutionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports